export default function ({ store, redirect }) {
  if (store.$auth.$state.user.user_role !== 3) {
    return redirect("/dashboard");
  }
}
